"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class C2dTintCache {
    constructor(nativeTexture) {
        this.nativeTexture = nativeTexture;
        this._colors = new Map();
        this._blancoTextures = [];
        this._lastCleanupFrame = 0;
        this._memTextures = 0;
    }
    get memoryUsage() {
        return this._memTextures * this.nativeTexture.w * this.nativeTexture.h;
    }
    releaseBlancoTextures() {
        this._memTextures -= this._blancoTextures.length;
        this._blancoTextures = [];
    }
    clear() {
        this._blancoTextures = [];
        this._colors.clear();
        this._memTextures = 0;
    }
    get(color) {
        let item = this._colors.get(color);
        if (!item) {
            item = { lf: -1, tx: undefined, u: -1 };
            this._colors.set(color, item);
        }
        return item;
    }
    set(color, texture, frame) {
        const item = this.get(color);
        item.lf = frame;
        item.tx = texture;
        item.u = frame;
        this._memTextures++;
    }
    cleanup(frame) {
        // We only need to clean up once per frame.
        if (this._lastCleanupFrame !== frame) {
            // We limit blanco textures reuse to one frame only to prevent memory usage growth.
            this._blancoTextures = [];
            this._colors.forEach((item, color) => {
                // Clean up entries that were not used last frame.
                if (item.lf < frame - 1) {
                    if (item.tx) {
                        // Keep as reusable blanco texture.
                        this._blancoTextures.push(item.tx);
                    }
                    this._colors.delete(color);
                }
            });
            this._lastCleanupFrame = frame;
        }
    }
    reuseTexture(frame) {
        // Try to reuse textures, because creating them every frame is expensive.
        this.cleanup(frame);
        if (this._blancoTextures && this._blancoTextures.length) {
            this._memTextures--;
            return this._blancoTextures.pop();
        }
    }
}
exports.C2dTintCache = C2dTintCache;
//# sourceMappingURL=C2dTintCache.js.map